import { TrellisHorizontalEdgeToolbar } from './HorizontalEdgeToolbar';
import { EDGE_TOOLBAR_HEIGHT } from './constants';
import { filterProps } from 'foundations-components/utils/filterProps';

// Adjustment to "pull up" the rotated toolbar to the expected top left position
import { jsx as _jsx } from "react/jsx-runtime";
const TOP_ADJUSTMENT = -1 * EDGE_TOOLBAR_HEIGHT;
const VerticalEdgeToolbar = props => {
  let {
    tokenProps: {
      insetBlockStart
    }
  } = filterProps(props);

  // If a custom top position is passed, make sure to combine it with the top adjustment, otherwise
  // it will be blown away by the overriding style
  insetBlockStart = insetBlockStart ? `calc(${insetBlockStart} + ${TOP_ADJUSTMENT}px)` : `${TOP_ADJUSTMENT}px`;
  return /*#__PURE__*/_jsx(TrellisHorizontalEdgeToolbar, Object.assign({
    dropdownPlacement: "right",
    rotateHandleIcon: "90deg",
    rotateActionIcons: "90deg",
    transform: "rotate(270deg) translate(-100%, 0)",
    transformOrigin: "left bottom 0",
    position: "relative"
  }, props, {
    insetBlockStart: insetBlockStart
  }));
};
export const TrellisVerticalEdgeToolbar = VerticalEdgeToolbar;
export default TrellisVerticalEdgeToolbar;